import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  ChakraProvider,
  useToast,
  Select,
  HStack,
  Textarea,
  FormHelperText,
  OrderedList,
  ListItem,
  Divider,
  Spacer,
} from '@chakra-ui/react';
import {
  IHealthPlanItem,
  IHealthPlanMappingItem,
  IHealthPlanType,
  IPayerAddressItem,
  IPayerMasterItem,
  IPayerName,
  IScenarioItem,
} from '../Infrastructure/Interfaces';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, Store } from '../Store/StoreInit';
import axios from 'axios';
import { fetchHealthPlanMappingList } from '../Store/HealthPlanMappingReducer';
import { useMsal } from '@azure/msal-react';
import {
  fetchHealthPlanTypeList,
  fetchPayerAddressList,
  fetchSceneriosList,
  fetchUnmappedHealthPlansList,
} from '../Store/GetDropDownsValuesReducer';
import { fetchPayerMasterList } from '../Store/PayerMasterReducer';
import { Space } from 'antd';

interface Props {
  isOpen?: any;
  onOpen?: any;
  onClose?: any;
  healthitems: IHealthPlanMappingItem[];
}

export const HealthPlansMappingMultiUpdateModal: React.FC<Props> = (
  props: Props
) => {
  const dispatch = useDispatch<AppDispatch>();
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const toast = useToast();
  const pname = props.healthitems[0]?.payerName;
  const { instance, accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;

  var payerAddresslist: IPayerAddressItem[] = useSelector((state: any) => {
    return state.payerAddressList.payerAddressList;
  });
  var healthplanlist: IHealthPlanType[] = useSelector((state: any) => {
    return state.healthPlanTypeList.healthPlanTypeList;
  });

  var scenariolist: IScenarioItem[] = useSelector((state: any) => {
    return state.scenariosList.scenariosList;
  });

  const [filteredAddressList, setFilteredAddressList] =
    useState(payerAddresslist);
  const [filteredScenarioList, setFilteredScenarioList] =
    useState(scenariolist);
  const [deliveryOption, setDeliveryOption] = useState<string[]>([]);
  const arrregionlist: string[] = (process.env.REACT_APP_REGION_LIST as string).split(',');
  const [isDisplayNameReq, setIsDisplayNameReq] = useState(false);
  const payermasterlist: IPayerMasterItem[] = useSelector((state: any) => {
    return state.payerMasterList.payerMasterList;
  });

  const [data, setdata] = useState({
    healthPlanMappingId: 0,
    healthPlanMasterId: 0,
    payerAddressId: props.healthitems[0]?.payerAddressId,
    payerMasterId: 0,
    payerName: props.healthitems[0]?.payerName,
    address: props.healthitems[0]?.address,
    city: props.healthitems[0]?.city,
    state: props.healthitems[0]?.state,
    zip: props.healthitems[0]?.zip,
    phoneNo: '',
    faxNo: '',
    displayName: props.healthitems[0]?.displayName,
    isActive: true,
    healthPlanTypeId: props.healthitems[0]?.healthPlanTypeId,
    healthPlanType: props.healthitems[0]?.healthPlanType,
    healthPlanName: '',
    region: '',
    createdBy: '',
    createdOn: '0001-01-01T00:00:00',
    modifiedBy: '',
    modifiedOn: '0001-01-01T00:00:00',
    scenarioid: 0,
    scenarioName: '',
    deliverOption: '',
    fax_to_fax_number: '',
    isunmapped: 0,
    healthPlanId: '',
  });

  // useEffect(() => {
  //   dispatch(fetchPayerMasterList());
  //   dispatch(fetchHealthPlanTypeList());
  //   dispatch(fetchSceneriosList());
  //   dispatch(fetchPayerAddressList());
  // }, []);

  useEffect(() => {
    setIsDisplayNameReq(false);
    //Store.subscribe(() => {
    setdata({
      ...data,
      //healthPlanMappingId: Store.getState().setHealthPlanMappingItem.value.healthPlanMappingId,
      //healthPlanMasterId: Store.getState().setHealthPlanMappingItem.value.healthPlanMasterId,
      payerAddressId: props.healthitems[0]?.payerAddressId,
      address: props.healthitems[0]?.address,
      payerName: props.healthitems[0]?.payerName,
      city: props.healthitems[0]?.city,
      state: props.healthitems[0]?.state,
      zip: props.healthitems[0]?.zip,
      phoneNo: props.healthitems[0]?.phoneNo,
      faxNo: props.healthitems[0]?.faxNo,
      displayName: props.healthitems[0]?.displayName,
      //isActive: props.healthitems[0]?.,
      healthPlanTypeId: props.healthitems[0]?.healthPlanTypeId,
      healthPlanType: props.healthitems[0]?.healthPlanType,
      //healthPlanName: Store.getState().setHealthPlanMappingItem.value.healthPlanName,
      region: props.healthitems[0]?.region,
      scenarioid: props.healthitems[0]?.scenarioId,
      scenarioName: props.healthitems[0]?.scenarioName,
      deliverOption: props.healthitems[0]?.deliverOption,
      fax_to_fax_number: props.healthitems[0]?.faxToFaxNumber,
      isunmapped: props.healthitems[0]?.healthPlanTypeId,
    });
    //})
  }, [props.healthitems]);

  const handleChange = (e: any) => {
    e.preventDefault();
    const { id, value } = e.target;
    setdata({
      ...data,
      [id]: value,
    });

    if (e.target.id == 'deliverOption') {
      setdata(prev => ({ ...prev, fax_to_fax_number: '' }));
    }

    if (e.target.id == 'payerAddressId') {
      var item = payerAddresslist.find(
        x =>
          x.payerAddressId ==
          (e.target.id == 'payerAddressId'
            ? e.target.value
            : data.payerAddressId)
      );
      let address = item?.address!;
      let city = item?.city!;
      let state = item?.state!;
      let zip = item?.zip!;
      let payerMasterId = item?.payerMasterId!;

      setdata({
        ...data,
        healthPlanMappingId: data.healthPlanMappingId,
        payerMasterId: payerMasterId,
        payerAddressId: e.target.value,
        address: address,
        city: city,
        state: state,
        zip: zip,
      });
    }
  };

  async function handleSubmit(e: { preventDefault: () => void }) {
    e.preventDefault();
    setSaveButtonLoading(true);

    if (data.displayName.trim() === '') {
      setIsDisplayNameReq(true);
      return;
    }

    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;

    props.healthitems?.forEach(async function (
      _healthPlanItem: IHealthPlanItem
    ) {
      const updatemappingdata = {
        healthPlanMappingId: _healthPlanItem.healthPlanMappingId,
        healthPlanMasterId: _healthPlanItem.healthPlanMasterId,
        payerAddressId: data.payerAddressId,
        healthPlanTypeId: _healthPlanItem.healthPlanTypeId,
        healthPlanName: _healthPlanItem.healthPlanName,
        displayName: data.displayName.trim(),
        region: data.region,
        isActive: data.isActive,
        createdBy: userid,
        createdOn: '0001-01-01T00:00:00',
        modifiedBy: userid,
        modifiedOn: '0001-01-01T00:00:00',
        scenarioid: data.scenarioid,
        user: accounts[0].username,
        healthPlanId: _healthPlanItem.healthPlanId,
      };

      const formdata = JSON.stringify(updatemappingdata);

      await axios.get(tokenurl).then(async res => {
        if (res.data.success) {
          await axios
            .put(baseurl + '/Payer/update_healthplanmapping', formdata, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + res.data.token,
              },
            })
            .then(response => {
              setSaveButtonLoading(false);
              if (response.data.success) {
                showToast('Success', response.data.message, 'success');
              }
            })
            .catch(error => {
              setSaveButtonLoading(false);
              showToast(
                'Error!',
                error.toString(),
                'error'
              );
            });
        }
      });
    });
    dispatch(fetchHealthPlanMappingList());
    props.onClose();
  }

  function showToast(
    title: string,
    description: string,
    status: 'info' | 'warning' | 'success' | 'error' | 'loading' | undefined
  ) {
    toast({
      title,
      description,
      position: 'top',
      status,
      duration: status === 'error' ? 10000 : 5000,
      isClosable: true,
    });
  }

  useEffect(() => {
    setFilteredAddressList(payerAddresslist.filter(x => x.payerName == pname));
  }, [pname]);

  useEffect(() => {
    setFilteredAddressList(
      payerAddresslist.filter(x => x.payerName == data.payerName)
    );
  }, [data.payerName]);

  //   useEffect(() => {
  //     setFilteredScenarioList(scenariolist.filter((x)=> x.billing_client == props.healthitems[0]?.region));
  //   }, [props.healthitems[0]?.region]);

  //   useEffect(() => {
  //     setFilteredScenarioList(scenariolist.filter((x)=> x.billing_client == data.region));
  //   }, [data.region]);

  useEffect(() => {
    const { deliverOption, region } = data;

    setFilteredScenarioList(
      scenariolist.filter(
        x => x.deliver_option === deliverOption && x.billing_client === region
      )
    );
  }, [data.deliverOption, data.region]);

  useEffect(() => {
    const { deliverOption, region, fax_to_fax_number } = data;

    setFilteredScenarioList(
      scenariolist.filter(
        x =>
          x.deliver_option === deliverOption &&
          x.billing_client === region &&
          x.fax_to_faxnumber === fax_to_fax_number
      )
    );
  }, [data.fax_to_fax_number]);

  useEffect(() => {
    const uniqueDeliverOptions = Array.from(
      new Set(scenariolist.map(scenario => scenario.deliver_option))
    );
    setDeliveryOption(uniqueDeliverOptions);
  }, []);

  return (
    <>
      <ChakraProvider>
        <Modal
          closeOnOverlayClick={true}
          size={'3xl'}
          isOpen={props.isOpen}
          onClose={props.onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <form onSubmit={handleSubmit}>
              <ModalHeader fontWeight="bold">
                <u>Map Health Plans with a Payer Address and Scenario</u>
              </ModalHeader>
              <ModalCloseButton color="black" />{' '}
              <ModalBody pb={6}>
                <FormControl mt={2}>
                  <HStack>
                    <FormLabel alignSelf="top" fontWeight="bold">
                      Health Plans Names:
                    </FormLabel>
                    <OrderedList>
                      {props.healthitems?.map(x => (
                        <ListItem key={x.healthPlanMasterId} fontSize="xs">
                          {x.healthPlanName}
                        </ListItem>
                      ))}
                    </OrderedList>
                    {/* <FormHelperText>{props.healthNames.filter((_healthNames:any, index:number) => index < 4)
                                .map((_filtershealthNames:any,newindex:number) =>
                                 <>  {newindex + 1}.   {_filtershealthNames} <br/></> )}</FormHelperText> */}
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Payer Name:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="payerName"
                      id="payerName"
                      defaultValue={data.payerName}
                      onChange={e => handleChange(e)}
                    >
                      {payermasterlist?.filter(x => x.isActive === true)
                          .map(_payername => (
                            <option
                              key={_payername.payerMasterId}
                              value={_payername.payerName}
                            >
                              {_payername.payerName}
                            </option>
                          ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Payer Address:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="payerAddressId"
                      id="payerAddressId"
                      defaultValue={data.payerAddressId}
                      onChange={e => handleChange(e)}
                    >
                      {filteredAddressList?.filter(x => x.isActive == true)
                          .map(payeraddress => (
                            <option
                              key={payeraddress.payerAddressId}
                              value={payeraddress.payerAddressId}
                            >
                              {payeraddress.payerName} -{payeraddress.address} -
                              {payeraddress.city} -{payeraddress.state} - (
                              {payeraddress.zip})
                            </option>
                          ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired isInvalid={isDisplayNameReq}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Display Name:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={100}
                      placeholder="Display Name"
                      name="displayName"
                      id="displayName"
                      defaultValue={data.displayName}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Plan Type:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="healthPlanTypeId"
                      id="healthPlanTypeId"
                      defaultValue={data.healthPlanTypeId}
                      onChange={e => handleChange(e)}
                      isDisabled={data.isunmapped > 0 ? true : false}
                    >
                      {healthplanlist?.map(healplantype => (
                          <option
                            key={healplantype.healthPlanTypeId}
                            value={healplantype.healthPlanTypeId}
                          >
                            {healplantype.healthPlanType}
                          </option>
                        ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Address:
                    </FormLabel>
                    <Input
                      size="sm"
                      isDisabled
                      placeholder="Address"
                      name="address"
                      id="address"
                      value={data.address}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      City:
                    </FormLabel>
                    <Input
                      size="sm"
                      isDisabled
                      placeholder="City"
                      name="city"
                      id="city"
                      value={data.city}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      State:
                    </FormLabel>
                    <Input
                      size="sm"
                      isDisabled
                      placeholder="State"
                      name="state"
                      id="state"
                      value={data.state}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Zip:
                    </FormLabel>
                    <Input
                      size="sm"
                      isDisabled
                      type="text"
                      placeholder="Zip"
                      name="zip"
                      id="zip"
                      value={data.zip}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Region:
                    </FormLabel>
                    <Select
                      size="sm"
                      isDisabled={data.region != '' ? true : false}
                      placeholder="--select Region--"
                      name="region"
                      id="region"
                      defaultValue={data.region}
                      onChange={e => handleChange(e)}
                    >
                      {arrregionlist?.map(regions => (
                          <option key={regions} value={regions}>
                            {regions}
                          </option>
                        ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Delivery Option:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="deliverOption"
                      id="deliverOption"
                      onChange={e => handleChange(e)}
                      defaultValue={data.deliverOption}
                    >
                      {deliveryOption?.map(deliveryOption => (
                          <option key={deliveryOption} value={deliveryOption}>
                            {deliveryOption}
                          </option>
                        ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl
                  mt={2}
                  hidden={data.deliverOption != 'Fax' ? true : false}
                >
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Fax Number:
                    </FormLabel>
                    <Input
                      size="sm"
                      isDisabled={data.deliverOption == 'Fax' ? false : true}
                      type="text"
                      id="fax_to_fax_number"
                      placeholder="Fax to Fax Number"
                      value={data.fax_to_fax_number}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider
                  mt={2}
                  hidden={data.deliverOption != 'Fax' ? true : false}
                />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Scenario:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="scenarioid"
                      id="scenarioid"
                      onChange={e => handleChange(e)}
                      defaultValue={data.scenarioid}
                    >
                      {filteredScenarioList?.map(scenario => (
                          <option
                            key={scenario.scenarioid}
                            value={scenario.scenarioid}
                          >
                            {scenario.name}
                          </option>
                        ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Active:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="isActive"
                      id="isActive"
                      defaultValue={data.isActive ? 'true' : 'false'}
                      onChange={handleChange}
                    >
                      <option value="true">True</option>
                      <option value="false">False</option>
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />
              </ModalBody>
              <ModalFooter>
                <Button bg="#002677" color="white" onClick={props.onClose}>
                  Cancel
                </Button>
                <Spacer />
                <Button
                  isLoading={saveButtonLoading}
                  bg="#002677"
                  color="white"
                  mr={3}
                  type="submit"
                  //onClick={(e) => handleSubmit(e)}
                >
                  Save
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </ChakraProvider>
    </>
  );
};
